import { ref, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'

export function useInactivityTimeout() {
  const store = useStore()
  const router = useRouter()
  const toast = useToast()
  
  // Durée d'inactivité : 1 heure (3600 secondes)
  const INACTIVITY_TIMEOUT = 60 * 60 * 1000 // 1 heure en millisecondes
  const WARNING_TIME = 5 * 60 * 1000 // Avertissement 5 minutes avant
  
  let inactivityTimer = null
  let warningTimer = null
  let lastActivity = Date.now()
  
  const resetTimers = () => {
    lastActivity = Date.now()
    
    // Nettoyer les timers existants
    if (inactivityTimer) clearTimeout(inactivityTimer)
    if (warningTimer) clearTimeout(warningTimer)
    
    // Timer d'avertissement (55 minutes)
    warningTimer = setTimeout(() => {
      if (store.getters['auth/isAuthenticated']) {
        toast.warning('⚠️ Vous serez déconnecté dans 5 minutes pour inactivité', {
          timeout: 10000
        })
      }
    }, INACTIVITY_TIMEOUT - WARNING_TIME)
    
    // Timer de déconnexion (60 minutes)
    inactivityTimer = setTimeout(() => {
      if (store.getters['auth/isAuthenticated']) {
        handleInactivityLogout()
      }
    }, INACTIVITY_TIMEOUT)
  }
  
  const handleInactivityLogout = () => {
    console.log('🔒 Déconnexion automatique pour inactivité')
    
    // Déconnecter l'utilisateur
    store.dispatch('auth/logout')
    
    // Afficher un message
    toast.error('Vous avez été déconnecté après 1 heure d\'inactivité', {
      timeout: 5000
    })
    
    // Rediriger vers la page de connexion
    router.push('/login')
    
    // Nettoyer les timers
    if (inactivityTimer) clearTimeout(inactivityTimer)
    if (warningTimer) clearTimeout(warningTimer)
  }
  
  const trackActivity = () => {
    // Ne suivre l'activité que si l'utilisateur est connecté
    if (store.getters['auth/isAuthenticated']) {
      resetTimers()
    }
  }
  
  const startTracking = () => {
    // Événements à surveiller pour détecter l'activité
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click'
    ]
    
    // Ajouter les écouteurs d'événements
    events.forEach(event => {
      document.addEventListener(event, trackActivity, true)
    })
    
    // Démarrer les timers
    if (store.getters['auth/isAuthenticated']) {
      resetTimers()
    }
  }
  
  const stopTracking = () => {
    // Événements à nettoyer
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click'
    ]
    
    // Retirer les écouteurs d'événements
    events.forEach(event => {
      document.removeEventListener(event, trackActivity, true)
    })
    
    // Nettoyer les timers
    if (inactivityTimer) clearTimeout(inactivityTimer)
    if (warningTimer) clearTimeout(warningTimer)
  }
  
  return {
    startTracking,
    stopTracking,
    resetTimers
  }
}
